import { render } from "./footer-text.vue?vue&type=template&id=35e49a7d&scoped=true"
import script from "./footer-text.vue?vue&type=script&lang=js"
export * from "./footer-text.vue?vue&type=script&lang=js"

import "./footer-text.vue?vue&type=style&index=0&id=35e49a7d&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e49a7d"]])

export default __exports__